var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown-expanded" }, [
    _c(
      "ul",
      { staticClass: "dropdown-expanded__list" },
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "dropdown-expanded__list__tag",
            class: [
              { "dropdown-expanded__list__tag--open": _vm.cloneId === item.id }
            ]
          },
          [
            _c("div", { staticClass: "dropdown-expanded__list__tag__header" }, [
              _c(
                "div",
                {
                  staticClass: "dropdown-expanded__list__tag__header__title",
                  on: {
                    click: function($event) {
                      return _vm.openthis(item)
                    }
                  }
                },
                [_c("h3", [_vm._v(_vm._s(item.title))])]
              ),
              item.toggle
                ? _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-expanded__list__tag__header__toggle",
                      class: [
                        {
                          "dropdown-expanded__list__tag__header__toggle--open":
                            _vm.cloneId === item.id
                        }
                      ]
                    },
                    [
                      _c("toggle-view", {
                        attrs: { "is-disabled": _vm.cloneId !== item.id },
                        on: { setResult: _vm.getToggleInfo }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !item.link
                ? _c(
                    "div",
                    {
                      staticClass: "dropdown-expanded__list__tag__header__icon",
                      class: [
                        {
                          "dropdown-expanded__list__tag__header__icon--rotate":
                            _vm.cloneId === item.id
                        }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.openthis(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "icon-arrow" })]
                  )
                : _vm._e()
            ]),
            item.text !== ""
              ? _c(
                  "div",
                  {
                    staticClass: "dropdown-expanded__list__tag__text",
                    class: [
                      {
                        "dropdown-expanded__list__tag__text--open":
                          _vm.cloneId === item.id
                      }
                    ]
                  },
                  [_c("p", [_vm._v(_vm._s(item.text))])]
                )
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45a436db", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a436db","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/dropdown-expanded-view.vue
// module id = 388
// module chunks = 68